export default "__VITE_ASSET__dh25EMQs__"